export default {
    page: function() {
        this.loadPosts()
    }
}
